import template from './CategoryItemView.html';
import { CategoryItemController } from './CategoryItemController';
export const CategoryItemComponent2 = {
    require: {
        ngModel: '?ngModel',
    },
    controller: CategoryItemController,
    controllerAs: '$ctrl',
    template,
    bindings: {
        data: '<',
        onDelete: '&?',
        onSave: '&?',
        elementId: '@?',
    },
};
